'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _card_component = require('./card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _ramda = require('ramda');

var _click_or_escape_outside = require('../click_or_escape_outside');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _dropdown_component = require('./dropdown_component');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _functional_utility = require('common-utilities/src/functional_utility');

var _accessibility_utility = require('../../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndex = (0, _ramda.addIndex)(_ramda.map);

var TabbedGenericComponent = function (_React$Component) {
  _inherits(TabbedGenericComponent, _React$Component);

  function TabbedGenericComponent(props) {
    _classCallCheck(this, TabbedGenericComponent);

    var _this = _possibleConstructorReturn(this, (TabbedGenericComponent.__proto__ || Object.getPrototypeOf(TabbedGenericComponent)).call(this, props));

    _this.state = {
      activeTab: 0,
      displayTab: true
    };
    _this.setActive = _this.setActive.bind(_this);
    _this.renderTabs = _this.renderTabs.bind(_this);
    _this.generateTab = _this.generateTab.bind(_this);
    _this.shouldShowTab = _this.shouldShowTab.bind(_this);
    _this.dropdownContent = _this.dropdownContent.bind(_this);
    return _this;
  }

  _createClass(TabbedGenericComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var tabbedData = this.props.tabbedData;

      var activeTabIndex = 0;

      for (var i = 0; i < tabbedData.length; i++) {
        if (!(0, _ramda.isNil)(tabbedData[i].tabContent)) {
          activeTabIndex = i;
          break;
        }
      }

      this.setState({
        activeTab: activeTabIndex
      });
    }
  }, {
    key: 'setActive',
    value: function setActive(event) {
      var eventAction = (0, _ramda.isNil)(event.target.getAttribute('data-eventAction')) ? event.target.parentNode.getAttribute('data-eventAction') : event.target.getAttribute('data-eventAction');
      var eventLabel = (0, _ramda.isNil)(event.target.getAttribute('data-eventLabel')) ? event.target.parentNode.getAttribute('data-eventLabel') : event.target.getAttribute('data-eventLabel');
      if (!(0, _ramda.isNil)(eventAction) && !(0, _ramda.isNil)(eventLabel)) {
        var trackingObject = {
          "eventCategory": 'pdp',
          "eventAction": eventAction,
          "eventLabel": eventLabel
        };
        _tracking_utility.TrackingUtility.trackEvent(trackingObject);
      }
      var activeTab = event.target.getAttribute('data-index');

      if (!activeTab) {
        activeTab = event.target.parentNode.getAttribute("data-index");
      }
      this.setState({ activeTab: parseInt(activeTab, 10) });
      if (!(0, _ramda.isNil)(this.props.onActiveTabChanged)) {
        this.props.onActiveTabChanged(activeTab);
      }
    }
  }, {
    key: 'isBreakdownListDataEmpty',
    value: function isBreakdownListDataEmpty(parentObject) {
      return (0, _ramda.isNil)(parentObject.tabContent);
    }
  }, {
    key: 'renderDropdown',
    value: function renderDropdown() {
      return this.shouldShowTab() ? _react2.default.createElement(
        'div',
        { id: this.props.cardID + 'Dropdown', className: 'table-tabs-container body2 margin-vertical-20' },
        _react2.default.createElement(
          _click_or_escape_outside2.default,
          { id: 'tabbed-card-selector-click-or-escape-outside' },
          _react2.default.createElement(_dropdown_component2.default, {
            dropdownContent: this.dropdownContent(this.props.tabbedData, this.state.activeTab),
            className: 'table-dropdown',
            id: 'tabbed-card-selector',
            breakpoint: this.props.breakpoint,
            initialActiveSelect: _react2.default.createElement(
              'div',
              null,
              this.props.tabbedData[this.state.activeTab].label
            ),
            alwaysOpenOnSelect: false
          })
        )
      ) : null;
    }
  }, {
    key: 'dropdownContent',
    value: function dropdownContent(dropdownData, activeTab) {
      var _this2 = this;

      var contents = [];
      var lastIndex = dropdownData.length - 1;
      var firstElement = void 0;
      if (!(0, _functional_utility.isNilOrEmpty)(dropdownData)) {
        firstElement = dropdownData[0].id + '_tabbed_generic_component';
      }
      mapIndex(function (dropdown, index) {
        var isLastElement = lastIndex === index;
        _this2[dropdown.id + '_tabbed_generic_component'] = _react2.default.createRef();
        if (!_this2.isBreakdownListDataEmpty(dropdown) && index !== activeTab) {
          contents.push(_react2.default.createElement(
            'div',
            {
              key: dropdown.id,
              tabIndex: '0',
              ref: _this2[dropdown.id + '_tabbed_generic_component'],
              className: 'dropdown-list-item',
              'data-testid': 'dropdown-on-change',
              'data-index': index,
              'data-label': dropdown.label,
              onClick: _this2.setActive,
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleDropdownEvents(_this2, event, '#' + _this2.props.cardID + 'Dropdown #tabbed-card-selector', dropdown.id + '_tabbed_generic_component', firstElement, isLastElement, _this2.setActive.bind(_this2, event));
              }
            },
            _react2.default.createElement(
              'span',
              { className: 'body2',
                'data-eventAction': dropdown.eventAction,
                'data-eventLabel': dropdown.eventLabel,
                'data-index': index },
              dropdown.label
            )
          ));
        }
      }, dropdownData);
      return contents;
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      var _this3 = this;

      var tabbedData = this.props.tabbedData;

      var tabMarkup = function tabMarkup(parentObject, index) {
        var firstElement = tabbedData[0].id;
        return _this3.isBreakdownListDataEmpty(parentObject) ? null : _this3.generateTab({ id: parentObject.id, label: parentObject.label, index: index, eventAction: parentObject.eventAction, eventLabel: parentObject.eventLabel, firstElement: firstElement });
      };
      var tabs = mapIndex(tabMarkup, tabbedData);

      return this.shouldShowTab() ? _react2.default.createElement(
        'div',
        { className: 'table-tabs-container caption margin-vertical-20' },
        _react2.default.createElement(
          'div',
          { className: 'table-tabs', role: 'tablist' },
          tabs
        )
      ) : null;
    }
  }, {
    key: 'shouldShowTab',
    value: function shouldShowTab() {
      return (0, _ramda.isNil)(this.props.displayTab) ? this.state.displayTab : this.props.displayTab;
    }
  }, {
    key: 'generateTab',
    value: function generateTab(opts) {
      var _this4 = this;

      var id = opts.id,
          label = opts.label,
          index = opts.index,
          eventAction = opts.eventAction,
          eventLabel = opts.eventLabel,
          firstElement = opts.firstElement;

      this[id + '_tab'] = _react2.default.createRef();
      return _react2.default.createElement(
        'div',
        { id: id,
          'data-index': index,
          role: 'tab',
          ref: this[id + '_tab'],
          tabIndex: '' + (this.state.activeTab === index ? "0" : "-1"),
          'aria-selected': '' + (this.state.activeTab === index ? "true" : "false"),
          'data-eventAction': eventAction,
          'data-eventLabel': eventLabel,
          className: 'table-tab ' + (this.state.activeTab === index ? "selected" : "") + ' text-center sub-header-3',
          onClick: this.setActive,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleTabEvents(_this4, event, id, id + '_tab', firstElement + '_tab', _this4.setActive.bind(_this4, event));
          }
        },
        label
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cardID = _props.cardID,
          tabbedData = _props.tabbedData,
          breakpoint = _props.breakpoint,
          activeCardHandler = _props.activeCardHandler;

      var headerTitleId = cardID + 'Header';
      var dataIsNotNil = function dataIsNotNil(data) {
        return !(0, _ramda.isNil)(data.tabContent);
      };
      var noAvailableData = (0, _ramda.filter)(dataIsNotNil, tabbedData);

      if ((0, _ramda.length)(noAvailableData) < 1) {
        return null;
      }

      var returnTypeTabs = breakpoint > 3 ? this.renderTabs() : this.renderDropdown();
      var disclosureText = tabbedData[this.state.activeTab].disclosureText;
      var placementId = tabbedData[this.state.activeTab].placementId;

      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card' },
        _react2.default.createElement(_reactWaypoint2.default, { topOffset: '35%', bottomOffset: '80%', onEnter: activeCardHandler.bind(this, headerTitleId) }),
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitleId: headerTitleId,
            disclosureText: disclosureText,
            placementId: placementId,
            breakpoint: breakpoint,
            headerTitle: this.props.headerTitle,
            headerTitleLabel: this.props.headerTitleLabel,
            headerLabel: this.props.headerLabel,
            shouldAlwaysShowMore: this.props.shouldAlwaysShowMore
          },
          _react2.default.createElement(
            'div',
            { id: cardID + 'Card' },
            returnTypeTabs,
            this.props.dateRangeComponent,
            this.props.tabbedData[this.state.activeTab].tabContent
          )
        )
      );
    }
  }]);

  return TabbedGenericComponent;
}(_react2.default.Component);

exports.default = TabbedGenericComponent;